import { Sparkles } from "lucide-react";

const PRIVACY_URL = "https://docs.google.com/document/d/151ibK7XPyU7Oo4KTfmUrwj3_Z0WxQ7NI/edit?usp=sharing&ouid=118030254887284270003&rtpof=true&sd=true";
const TERMS_URL = "https://docs.google.com/document/d/1DAZhD5SxETWHd_diJoD3heMq3qIi-OnP/edit?usp=sharing&ouid=118030254887284270003&rtpof=true&sd=true";

export default function Footer() {
  return (
    <footer className="border-t border-[#e5e7eb] bg-[#FAFAF8]" data-testid="app-footer">
      <div className="container-bsp py-8 flex flex-col gap-5 text-sm text-[#52525b]">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-[#D4A853]" />
            <span>© 2026 BrandSnap.pro</span>
          </div>
          <nav className="flex items-center gap-6">
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#1A1F3D] transition-colors" data-testid="footer-privacy">Privacy Policy</a>
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#1A1F3D] transition-colors" data-testid="footer-terms">Terms of Use</a>
            <a href="mailto:contact@aicompass.co.uk" className="hover:text-[#1A1F3D] transition-colors">contact@aicompass.co.uk</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
